<app-loading *ngIf="isLoading" [style]="'tailwind'" [message]="'載入中...'" [background]="'overlay'"></app-loading>

<main *ngIf="!isLoading" class="min-h-full bg-app-canvas">
  <section class="relative min-h-[220px] overflow-hidden border-b-[6px] border-app-highlight sm:min-h-[260px]">
    <img [src]="heroBackgroundImage" alt="碧雲莊" class="absolute inset-0 h-full w-full object-cover"
      (error)="onHeroImageError($event)" loading="eager">
    <div class="absolute inset-0 bg-black/50"></div>
    <div class="relative mx-auto flex min-h-[220px] w-full max-w-6xl items-end px-4 pb-6 sm:min-h-[260px] sm:px-6 sm:pb-8">
      <div class="flex w-full flex-col gap-3 text-white sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p class="mb-1 text-sm font-medium text-white/80">歡迎使用</p>
          <h1 class="text-2xl font-bold">碧雲莊雲幣App</h1>
        </div>
        <div class="flex items-baseline gap-2 rounded-lg border border-l-4 border-white/40 border-l-app-highlight bg-black/70 px-4 py-3 shadow-hero-label">
          <span class="text-sm font-medium text-white/80">可用餘額</span>
          <strong class="app-numeric text-xl text-white">{{ user.total_time }}</strong>
          <span class="text-sm text-white/80">雲幣</span>
        </div>
      </div>
    </div>
  </section>

  <div class="mx-auto w-full max-w-6xl space-y-5 px-3 py-5 sm:px-6 sm:py-6">
    <nav class="grid grid-cols-1 gap-2 min-[340px]:grid-cols-2 sm:grid-cols-4" aria-label="常用功能">
      <button type="button" class="flex min-h-20 min-w-0 items-center gap-3 rounded-lg border border-app-brand-border-soft bg-app-brand-wash px-3 py-3 text-left text-app-brand-dark"
        (click)="navigateTo('/create-task-category-page')">
        <span class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-app-brand text-white" aria-hidden="true"><i class="bi bi-plus-lg"></i></span>
        <span class="min-w-0 font-bold">發起任務</span>
      </button>
      <button type="button" class="flex min-h-20 min-w-0 items-center gap-3 rounded-lg border border-app-accent-border-soft bg-app-accent-soft px-3 py-3 text-left text-app-accent-dark"
        (click)="navigateTo('/category-page')">
        <span class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-app-accent text-white" aria-hidden="true"><i class="bi bi-search"></i></span>
        <span class="min-w-0 font-bold">找尋任務</span>
      </button>
      <button type="button" class="flex min-h-20 min-w-0 items-center gap-3 rounded-lg border border-app-supply-border bg-app-supply-soft px-3 py-3 text-left text-app-supply-dark"
        (click)="navigateTo('/create-task-history')">
        <span class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-app-supply text-white" aria-hidden="true"><i class="bi bi-send-check-fill"></i></span>
        <span class="min-w-0 font-bold">我發起的</span>
      </button>
      <button type="button" class="flex min-h-20 min-w-0 items-center gap-3 rounded-lg border border-app-highlight-border bg-app-highlight-soft px-3 py-3 text-left text-app-highlight-text"
        (click)="navigateTo('/accept-task-history')">
        <span class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-app-highlight text-app-ink" aria-hidden="true"><i class="bi bi-person-check-fill"></i></span>
        <span class="min-w-0 font-bold">我接受的</span>
      </button>
    </nav>

    <section class="overflow-hidden rounded-lg border border-app-highlight-line bg-white shadow-highlight-md">
      <div class="flex items-center justify-between border-b border-slate-200 bg-app-highlight-soft px-4 py-3 sm:px-5">
        <div class="flex items-center gap-2.5">
          <span class="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-app-accent text-white" aria-hidden="true"><i class="bi bi-megaphone-fill app-icon"></i></span>
          <h2 class="app-section-title text-slate-900">最新公告</h2>
        </div>
        <span *ngIf="announcements.length" class="app-numeric text-sm text-app-ink-muted">
          {{ currentSlide + 1 }} / {{ announcements.length }}
        </span>
      </div>

      <ng-container *ngIf="announcements.length > 0; else noAnnouncements">
      <button type="button" class="block w-full whitespace-normal text-left focus:outline-none focus:ring-2 focus:ring-inset focus:ring-app-brand-soft"
        (click)="viewAnnouncementDetail(announcements[currentSlide])">
        <img [src]="announcements[currentSlide].image_url" [alt]="announcements[currentSlide].title"
          class="h-40 w-full object-cover sm:h-52">
        <div class="px-4 py-4 sm:px-5">
          <h3 class="font-bold leading-snug text-app-ink">{{ announcements[currentSlide].title }}</h3>
          <p class="mt-2 whitespace-normal text-sm leading-relaxed text-app-ink-muted">{{ announcements[currentSlide].description }}</p>
          <span class="app-numeric mt-2 block text-xs text-app-ink-muted">
            {{ announcements[currentSlide].created_at | date: 'yyyy/MM/dd' }}
          </span>
        </div>
      </button>

      <div *ngIf="announcements.length > 1" class="flex items-center justify-between border-t border-slate-200 px-3 py-2">
        <button type="button" class="app-icon-button border-0"
          (click)="prevSlide(); stopAutoSlide(); startAutoSlide()" aria-label="上一則公告">
          <i class="bi bi-chevron-left app-icon" aria-hidden="true"></i>
        </button>
        <div class="flex gap-2" aria-label="公告頁次">
          <button *ngFor="let announcement of announcements; let i = index" type="button"
            class="h-2.5 w-2.5 rounded-full"
            [style.background-color]="i === currentSlide ? 'var(--app-color-brand)' : 'var(--app-color-border)'"
            (click)="goToSlide(i); stopAutoSlide(); startAutoSlide()"
            [attr.aria-label]="'第 ' + (i + 1) + ' 則公告'"></button>
        </div>
        <button type="button" class="app-icon-button border-0"
          (click)="nextSlide(); stopAutoSlide(); startAutoSlide()" aria-label="下一則公告">
          <i class="bi bi-chevron-right app-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="border-t border-slate-200 px-4 py-4 sm:px-5">
        <h3 class="app-field-label mb-3 text-slate-700">近期公告</h3>
        <div class="divide-y divide-slate-200">
          <button *ngFor="let announcement of announcements.slice(0, 3)" type="button"
            class="flex min-h-14 w-full items-center justify-between gap-3 whitespace-normal py-3 text-left focus:outline-none focus:ring-2 focus:ring-inset focus:ring-app-brand-soft"
            (click)="viewAnnouncementDetail(announcement)">
            <span class="min-w-0">
              <span class="block whitespace-normal font-semibold text-slate-800">{{ announcement.title }}</span>
              <span class="app-numeric mt-1 block text-xs text-app-ink-muted">{{ announcement.created_at | date: 'MM/dd' }}</span>
            </span>
            <i class="bi bi-chevron-right app-icon flex-shrink-0 text-slate-400" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      </ng-container>
      <ng-template #noAnnouncements>
        <div class="px-4 py-8 text-center text-slate-500 sm:px-5">目前沒有公告</div>
      </ng-template>
    </section>

    <section class="overflow-hidden rounded-lg border border-app-brand-border-soft bg-white shadow-brand-md">
      <div class="flex flex-col gap-3 border-b border-slate-200 bg-app-brand-tint px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
        <div class="flex items-center gap-2.5">
          <span class="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-app-brand text-white" aria-hidden="true"><i class="bi bi-list-check app-icon"></i></span>
          <h2 class="app-section-title text-slate-900">最新任務</h2>
        </div>
        <div class="grid grid-cols-2 rounded-lg bg-slate-100 p-1 sm:w-auto">
          <button type="button" class="min-h-11 rounded-md px-3 py-2 font-semibold transition-colors"
            [class]="showSupply ? 'app-supply-surface shadow-sm' : 'text-slate-600'"
            (click)="toggleTaskType(true)">我可以提供</button>
          <button type="button" class="min-h-11 rounded-md px-3 py-2 font-semibold transition-colors"
            [class]="!showSupply ? 'app-accent-surface shadow-sm' : 'text-slate-600'"
            (click)="toggleTaskType(false)">我需要幫忙</button>
        </div>
      </div>

      <div class="border-b border-slate-200 px-3 py-3 sm:px-5">
        <h3 class="app-field-label mb-3 text-slate-700">選擇分類</h3>
        <div class="relative">
          <button type="button" class="absolute left-0 top-1/2 z-10 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 shadow-sm"
            (click)="scrollCategories('left')" [class.opacity-30]="!canScrollLeft" [disabled]="!canScrollLeft" aria-label="向左瀏覽分類">
            <i class="bi bi-chevron-left app-icon" aria-hidden="true"></i>
          </button>
          <div #categoryScrollContainer class="overflow-x-auto px-12" (scroll)="onCategoryScroll()"
            (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
            <div class="flex gap-2 py-1">
              <button type="button" class="flex min-h-12 flex-shrink-0 items-center gap-2 rounded-lg border px-3 py-2 font-medium"
                [class]="selectedCategoryId === null ? 'app-brand-surface border-transparent' : 'border-slate-200 bg-white text-slate-700'"
                (click)="selectCategory(null)">
                <img [src]="getCategoryIconPath('其他.png')" class="h-7 w-7 object-contain" alt="">
                全部
              </button>
              <button *ngFor="let category of categories; trackBy: trackByCategory" type="button"
                class="flex min-h-12 flex-shrink-0 items-center gap-2 rounded-lg border px-3 py-2 font-medium"
                [style.background-color]="selectedCategoryId === category.id ? category.color : 'var(--app-color-surface)'"
                [style.border-color]="category.color || 'var(--app-color-border)'"
                [style.color]="selectedCategoryId === category.id ? getContrastingTextColor(category.color) : 'var(--app-color-ink)'"
                (click)="selectCategory(category.id)">
                <img [src]="getCategoryIconPath(category.icon_url)" class="h-7 w-7 object-contain" alt="">
                <span class="h-2.5 w-2.5 flex-shrink-0 rounded-full" [style.background-color]="category.color" aria-hidden="true"></span>
                {{ category.title }}
              </button>
            </div>
          </div>
          <button type="button" class="absolute right-0 top-1/2 z-10 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 shadow-sm"
            (click)="scrollCategories('right')" [class.opacity-30]="!canScrollRight" [disabled]="!canScrollRight" aria-label="向右瀏覽分類">
            <i class="bi bi-chevron-right app-icon" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="p-4 sm:p-5">
        <div class="mb-4 inline-flex items-center rounded-lg border px-3 py-2 font-medium"
          [style.background-color]="selectedCategoryId ? getSelectedCategoryColor() : 'var(--app-color-surface-panel)'"
          [style.border-color]="selectedCategoryId ? getSelectedCategoryColor() : 'var(--app-color-border)'"
          [style.color]="selectedCategoryId ? getContrastingTextColor(getSelectedCategoryColor()) : 'var(--app-color-ink)'"
          >
          {{ selectedCategoryId ? getSelectedCategoryName() : '全部分類' }} ·
          <span class="ml-1 font-bold">{{ showSupply ? '供給' : '需求' }}</span>
        </div>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <button *ngFor="let task of getFilteredTasks(); trackBy: trackByTask" type="button"
            class="overflow-hidden whitespace-normal rounded-lg border border-b-[3px] border-app-border bg-app-surface text-left shadow-app-subtle focus:outline-none focus:ring-2 focus:ring-app-brand-soft"
            (click)="viewTaskDetail(task)">
            <div class="relative h-36 overflow-hidden">
              <img [src]="task.image_url" [alt]="task.title" class="h-full w-full object-cover" loading="lazy" (error)="onTaskImageError($event)">
              <span class="absolute left-2 top-2 rounded-full px-2.5 py-1 font-semibold text-white"
                [class]="task.is_supply ? 'app-supply-surface' : 'app-accent-surface'">
                {{ task.is_supply ? '供給' : '需求' }}
              </span>
              <span class="app-numeric absolute right-2 top-2 rounded-full bg-black/75 px-2.5 py-1 text-xs font-semibold text-white">
                {{ task.costTime }} 雲幣
              </span>
            </div>
            <div class="p-3.5">
              <h3 class="font-bold leading-snug text-app-ink">{{ getTaskDisplayText(task) }}</h3>
              <p class="mt-2 whitespace-normal text-sm leading-relaxed text-app-ink-muted">{{ task.description }}</p>
              <div class="mt-3 flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
                <span class="app-numeric text-xs text-app-ink-muted">{{ task.createAt | date: 'MM/dd' }}</span>
                <span class="text-sm font-semibold text-app-brand">查看詳情</span>
              </div>
            </div>
          </button>
        </div>

        <div *ngIf="getFilteredTasks().length === 0" class="py-10 text-center">
          <h3 class="font-bold text-slate-800">目前沒有任務</h3>
          <p class="mt-2 text-slate-500">
            {{ selectedCategoryId ? getSelectedCategoryName() : '全部分類' }}中暫時沒有
            <span [class]="showSupply ? 'text-app-supply' : 'app-accent-text'">{{ showSupply ? '供給' : '需求' }}</span>任務
          </p>
          <button type="button" class="app-brand-button mt-4 inline-flex min-h-12 items-center justify-center rounded-lg px-5 py-3 font-bold"
            (click)="createNewTask()">發布新任務</button>
        </div>
      </div>
    </section>
  </div>
</main>
